<div class="auth-layout">
  <div class="form-section">
    <div class="logo">
      <app-cintra-cloud-logo title="Welcome to Cintra People &trade;"></app-cintra-cloud-logo>
    </div>
    <div class="form-container">
      <div class="form-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="illustration-section">
    <div class="illustration-group left">
      <img src="assets/img/auth/Elements-Green.svg" class="elements-green" />
      <img src="assets/img/auth/hr-Illustration.png" class="hr-illustration slide-fwd-center" />
    </div>
    <div class="illustration-group right">
      <img src="assets/img/auth/Elements-Blue.svg" class="elements-blue" />
      <img src="assets/img/auth/payroll-Illustration.png" class="payroll-illustration slide-fwd-center" />
    </div>
  </div>
</div>
